import { Directive, HostBinding, inject, Input, OnDestroy, OnInit } from '@angular/core';

import { createA11yId, normalizeAriaValue } from '../utils/a11y.util';

import { A11yDisclosureDirective } from './a11y-disclosure.directive';

@Directive({
  selector: '[khA11yDisclosurePanel]',
  exportAs: 'khA11yDisclosurePanel'
})
export class A11yDisclosurePanelDirective implements OnInit, OnDestroy {
  private readonly disclosure = inject(A11yDisclosureDirective, { optional: true });
  private readonly generatedId = createA11yId('kh-a11y-disclosure-panel');

  @Input('khA11yDisclosurePanel') public panelId: string | null = null;

  @HostBinding('attr.id')
  public get id(): string {
    return normalizeAriaValue(this.panelId) ?? this.generatedId;
  }

  public ngOnInit(): void {
    this.disclosure?.registerPanel(this.id);
  }

  public ngOnDestroy(): void {
    this.disclosure?.unregisterPanel(this.id);
  }
}
